import { fetchAuthSession } from "aws-amplify/auth";
import {
  createAuthHelpers,
  createApiFetch,
  createAuditContextHeadersFn,
} from "@hiya/ui";
import { isStub, signOut } from "../auth/auth-service";

export const API_BASE = import.meta.env.VITE_API_BASE_URL || "";

// Re-export for consumers that import from client.ts
export { parseApiError } from "@hiya/ui";

const { handleUnauthorized, getAuthHeaders } = createAuthHelpers({ isStub, signOut, fetchAuthSession });

export { handleUnauthorized, getAuthHeaders };

const getAuditContextHeaders = createAuditContextHeadersFn({
  appVersion: import.meta.env.VITE_APP_VERSION,
  // Locale: i18n not yet in use; auditContext falls back to
  // navigator.language. When a locale provider lands, pass it via the
  // `getLanguage` option here.
});

export const apiFetch = createApiFetch(
  API_BASE,
  getAuthHeaders,
  handleUnauthorized,
  getAuditContextHeaders,
);
